export const DEVICE_DETAILS = 'device-details';
export const DEVICE_DETAILS_RESULT = `${DEVICE_DETAILS}/result`;
export const DEVICE_DETAILS_CLEAR = `${DEVICE_DETAILS}/clear`;
